/**
 * Prix dynamique avec les complements (SS - Product Addons)
 *
 * La section "SS - Product Addons" ajoute les produits complementaires au
 * panier, mais ne touche pas au prix affiche : il restait sur le prix du
 * produit seul. Ce script additionne le prix des complements coches au bloc
 * prix de la fiche produit (prix courant, et prix barre si le produit est en
 * promo).
 *
 * Le prix du bouton "Ajouter au panier" suit automatiquement : son script
 * (sections/main-product.liquid) relit le bloc prix a chaque changement.
 *
 * Sense re-rend le bloc prix a chaque changement de variante : un
 * MutationObserver re-applique alors les complements sur le nouveau prix.
 *
 * Charge uniquement si le reglage de theme "addons_dynamic_price" est coche.
 *
 * Version: 2026-09-25-r1
 */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script) return;
  var container = document.querySelector(script.getAttribute('data-price-container'));
  if (!container) return;

  var moneyFormat = (script.getAttribute('data-money-format') || '').replace(/<[^>]*>/g, '');
  var noDecimals = moneyFormat.indexOf('no_decimals') !== -1;

  var ADDON_INPUT = 'input[type="checkbox"][id^="buy-more-input-"]';

  function toCents(text) {
    var digits = (text || '').replace(/[^\d]/g, '');
    if (!digits) return null;
    var value = parseInt(digits, 10);
    return noDecimals ? value * 100 : value;
  }

  function formatMoney(cents) {
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    function withDelimiters(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var units = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return units + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = withDelimiters(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(2, '\'', '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(2, ' ', ','); break;
      default: value = withDelimiters(2, ',', '.');
    }
    return match ? moneyFormat.replace(match[0], value) : value;
  }

  function addonsTotals() {
    var totals = { price: 0, compare: 0 };
    var inputs = document.querySelectorAll(ADDON_INPUT + ':checked');
    Array.prototype.forEach.call(inputs, function (input) {
      var row = input.closest('[class*="buy-more-product-"]');
      var priceEl = row && row.querySelector('[class*="buy-more-upsell-price-"]');
      var price = priceEl ? toCents(priceEl.textContent) : null;
      if (price == null) return;
      var compareEl = row.querySelector('[class*="buy-more-compare-price-"]');
      var compare = compareEl ? toCents(compareEl.textContent) : null;
      totals.price += price;
      totals.compare += (compare && compare > price) ? compare : price;
    });
    return totals;
  }

  // Memorise le prix d'origine rendu par Sense la premiere fois qu'on voit
  // l'element (un nouveau rendu de variante cree de nouveaux elements), puis
  // affiche prix d'origine + complements, ou le texte d'origine s'il n'y en a pas.
  function update(el, extra) {
    if (!el) return;
    if (!el.hasAttribute('data-base-cents')) {
      var cents = toCents(el.textContent);
      if (cents == null) return;
      el.setAttribute('data-base-cents', cents);
      el.setAttribute('data-base-text', el.textContent);
    }
    el.textContent = extra
      ? formatMoney(parseInt(el.getAttribute('data-base-cents'), 10) + extra)
      : el.getAttribute('data-base-text');
  }

  var observer = new MutationObserver(apply);

  function apply() {
    var totals = addonsTotals();
    var onSale = !!container.querySelector('.price--on-sale');
    update(container.querySelector('.price__regular .price-item--regular'), totals.price);
    update(container.querySelector('.price__sale .price-item--sale'), totals.price);
    // Sense laisse le prix barre dans le DOM hors promo (masque, a 0,00) : on
    // n'y touche que si le produit est reellement en promo.
    if (onSale) update(container.querySelector('.price__sale .price-item--regular'), totals.compare);
    // Ignore les mutations causees par nos propres ecritures.
    observer.takeRecords();
  }

  observer.observe(container, { childList: true, subtree: true });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches(ADDON_INPUT)) apply();
  });
})();
